import { NgModule } from 'ng-metadata/core';
import { SummaryComponent } from './summary.component';
import { SummaryItemModule } from './summary-item/summary-item.module';

@NgModule({
  imports: [SummaryItemModule],
  declarations: [SummaryComponent],
})
export class SummaryModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/summary/summary.module.ts